import { Box, Text, Tooltip, Icon, VStack, HStack } from '@chakra-ui/react';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import config from '@/config.json';
import CopyCellRenderer from 'components/tables/AGGrid/CustomCells/CopyCellRenderer';

const TelephoneNumberCellRenderer = ({
    data,
    operatorStatus,
    operatorMessage,
}) => {
    const result = () => {
        if (!data.isLicensed) {
            return 'Not Licensed';
        }

        // User is licensed
        if (
            data.msCallingPlanEnabled &&
            data.platformID === 'fac64979-385b-42ce-8b1c-d30e87822304'
        ) {
            return 'MS Calling Plan Assigned';
        }

        // MS Calling Plan not enabled
        if (!data.msCallingPlanEnabled) {
            if (!data.userProfiles || data.userProfiles.length === 0) {
                return config.notAllocated.table;
            }

            const raw = data.userProfiles[0]?.platformNumber?.telephoneNumber;
            if (raw) {
                return raw;
            }
        }

        return 'Not Licensed';
    };

    const rawValue = result();
    const formattedValue =
        rawValue &&
        rawValue !== 'Not Licensed' &&
        rawValue !== 'MS Calling Plan Assigned' &&
        rawValue !== config.notAllocated.table
            ? `+${rawValue}`
            : rawValue;

    const operatorStatusTip =
        'Operator Status: ' + config.numbers.operatorStatusJSON[operatorStatus];
    const operatorMessageTip = 'Operator Message: ' + operatorMessage;

    const hasOperatorInfo = operatorStatus != null || operatorMessage;

    const content = (
        <CopyCellRenderer value={rawValue} valueFormatted={formattedValue} />
    );

    if (!hasOperatorInfo) return content;

    return (
        <Tooltip
            hasArrow
            portalProps={{ containerRef: undefined }}
            maxW="400px"
            width="auto"
            label={
                <Box display="flex" alignItems="left">
                    <VStack spacing="5px" align="start">
                        {operatorStatus != null && (
                            <HStack spacing={0} align="center">
                                <Icon
                                    as={IoMdInformationCircleOutline}
                                    marginRight="5px"
                                    color="white"
                                />
                                <Text textAlign="left">
                                    {operatorStatusTip}
                                </Text>
                            </HStack>
                        )}
                        {operatorMessage && (
                            <Text textAlign="left">{operatorMessageTip}</Text>
                        )}
                    </VStack>
                </Box>
            }>
            {content}
        </Tooltip>
    );
};

export default TelephoneNumberCellRenderer;
